import { Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { Treatment } from './Treatment';

interface ITreatments {
  treatmentMethods: string[];
}

export const Treatments = ({ treatmentMethods }: ITreatments) => {
  if (treatmentMethods.length === 0) return null;

  return (
    <Stack gap='8px'>
      <Typography
        variant='body5'
        component='h4'
        sx={{
          cursor: 'text',
        }}
      >
        {Dictionary[DICTIONARY.Suppliers].resultPage.therapy.treatmentMethods}
      </Typography>
      <Stack
        direction='row'
        gap='8px'
        flexWrap='wrap'
        sx={{
          pr: '24px',
        }}
      >
        {treatmentMethods.map((method: string, index: number) => {
          return <Treatment key={index} treatmentMethod={method} />;
        })}
      </Stack>
    </Stack>
  );
};
